import { getFeaturesListFromAPI } from "@/services/setting.service";
import { ALL_FEATURES } from "@/utils/constants/constants";
import { getFromLocalStorage, storeInLocalStorage } from "@/utils/functions/helperFunctions";
import { getAllOrganizations, getCurrentOrganization } from "@/utils/functions/OrganizationFunctions";

export const SUPERADMIN_ROLE = "superadmin";

export function isSuperAdmin() {
  const organizations = getAllOrganizations();
  if (!organizations) return false;
  return organizations.some((org: any) =>
    org?.roles?.some((role: { name: string }) => role.name === SUPERADMIN_ROLE)
  );
}

const FEATURES_LOADED_EVENT = "gs-features-loaded";

const parseFeaturesFromStorage = () => {
    const raw = getFromLocalStorage(ALL_FEATURES);
    if (!raw || raw === "undefined" || raw === "null") {
        return null;
    }
    try {
        return JSON.parse(raw) as { name: string; position: number }[];
    } catch {
        return null;
    }
};

export function isFeaturePermitted(featureName: string): boolean {
    let features = parseFeaturesFromStorage();
    if (!features) {
        void getFeaturesListFromAPI()
            .then((response: any) => {
                storeInLocalStorage(ALL_FEATURES, response.data.features);
                window.dispatchEvent(new Event(FEATURES_LOADED_EVENT));
            })
            .catch(() => {});
        return false;
    }

    const position = features.find((feature) => feature.name === featureName)?.position;
    if (position === undefined) {
        return false;
    }

    const userOrganization = getCurrentOrganization();
    if (!userOrganization?.rbac) {
        return false;
    }

    return Boolean(userOrganization.rbac[position]);
}

export { FEATURES_LOADED_EVENT };
